module.exports = __webpack_public_path__ + "static/copywriting-d2ee4a437481d3b7b7a6e667aa1b1f5b.png";